import { TableCellWithBadge } from "../../../../data-model/tableCells";

export enum RouteVia {
  CMM = "CMM",
  SURESCRIPTS = "Surescripts",
  PROMPT_PA = "PromptPA",
  PHONE_PA = "PhonePA",
  FAX_PA = "FaxPA",
  OTHERS = "Others",
}

interface RouteViaBadgeStyles {
  text: string;
  textColor: string;
  bgColor: string;
}

const GREY_BADGE_BG = "#F5F5F5";
const BLACK_TEXT = "#111111";

const routeViaStyles: Record<RouteVia, RouteViaBadgeStyles> = {
  [RouteVia.CMM]: {
    text: "CMM",
    textColor: BLACK_TEXT,
    bgColor: GREY_BADGE_BG,
  },
  [RouteVia.SURESCRIPTS]: {
    text: "Surescripts",
    textColor: BLACK_TEXT,
    bgColor: GREY_BADGE_BG,
  },
  [RouteVia.PROMPT_PA]: {
    text: "Prompt PA",
    textColor: BLACK_TEXT,
    bgColor: GREY_BADGE_BG,
  },
  [RouteVia.PHONE_PA]: {
    text: "Phone PA",
    textColor: BLACK_TEXT,
    bgColor: GREY_BADGE_BG,
  },
  [RouteVia.FAX_PA]: {
    text: "Fax PA",
    textColor: BLACK_TEXT,
    bgColor: GREY_BADGE_BG,
  },
  [RouteVia.OTHERS]: {
    text: "Others",
    textColor: BLACK_TEXT,
    bgColor: GREY_BADGE_BG,
  },
};

/**
 * Gets the badge styles for a Route Via value
 */
export const getRouteViaBadgeStyles = (
  routeVia: string | null | undefined,
): TableCellWithBadge => {
  const defaultStyles: TableCellWithBadge = {
    text: "--",
    color: BLACK_TEXT,
    bgColor: GREY_BADGE_BG,
    hoverText: "--",
  };

  if (!routeVia || routeVia === "--") {
    return defaultStyles;
  }

  const normalizedValue = routeVia.trim();

  // Find matching route via (case-insensitive)
  const matchedKey = Object.values(RouteVia).find(
    (key) => key.toLowerCase() === normalizedValue.toLowerCase(),
  );

  if (matchedKey) {
    const styles = routeViaStyles[matchedKey];
    return {
      text: styles.text,
      color: styles.textColor,
      bgColor: styles.bgColor,
      hoverText: styles.text,
    };
  }

  // Return default with original text if no match
  return {
    text: normalizedValue,
    color: BLACK_TEXT,
    bgColor: GREY_BADGE_BG,
    hoverText: normalizedValue,
  };
};
